import React from 'react';
import { Typography } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { GenericObject } from '@fnol/library/src/lib';
import { translations } from '../../lib/consts';
import './success.css';

type Props = {
    claimNo: GenericObject[];
};

const SuccessScreen = ({ claimNo }: Props) => {
    return (
        <>
            <div className="success-wrapper">
                <Typography variant="subtitle1">{translations.success.SUCCESS}</Typography>
                {!!claimNo ? (
                    <Typography variant="subtitle1" id="claimNo">
                        <>
                            {translations.success.CLAIM_NUMBER} {claimNo}
                        </>
                    </Typography>
                ) : null}
                <Typography variant="subtitle1">{translations.success.NOTIFICATION_SEND}</Typography>
            </div>
            <CheckCircleOutline className="checkIcon" fontSize="large" />
        </>
    );
};

export default SuccessScreen;
